import React, { useState, useEffect } from 'react';
import AdminSidebar, { TAB_KEYS } from './admin/AdminSidebar';
import UsersTab from './admin/UsersTab';
import AbandonedTab from './admin/AbandonedTab';
import PromptsTab from './admin/PromptsTab';
import RatesTab from './admin/RatesTab';
import QueueTab from './admin/QueueTab';
import DomainsTab from './admin/DomainsTab';
import SettingsTab from './admin/SettingsTab';
import BillingTab from './admin/BillingTab';
import OrganizationsTab from './admin/OrganizationsTab';
import PaymentsTab from './admin/PaymentsTab';
import TrialRequestsTab from './admin/TrialRequestsTab';
import MetricsDashboard from './MetricsDashboard';

// Список разделов берётся из боковой панели, а не дублируется здесь: свой
// список тут уже разъехался с ней (см. комментарий к TAB_KEYS в AdminSidebar).
export function readHashTab() {
  const m = (window.location.hash || '').match(/^#admin\/(\w+)/);
  return m && TAB_KEYS.includes(m[1]) ? m[1] : 'users';
}

export default function AdminPanel({ onBack }) {
  const [active, setActive] = useState(readHashTab());
  const [candidateCount, setCandidateCount] = useState(0);

  useEffect(() => {
    const onHash = () => setActive(readHashTab());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const select = (key) => { window.location.hash = `#admin/${key}`; setActive(key); };

  const TABS = {
    users: <UsersTab onCandidateCount={setCandidateCount} />,
    domains: <DomainsTab />,
    metrics: <MetricsDashboard />,
    queue: <QueueTab />, abandoned: <AbandonedTab />,
    prompts: <PromptsTab />, rates: <RatesTab />, settings: <SettingsTab />,
    billing: <BillingTab />,
    trials: <TrialRequestsTab />,
    organizations: <OrganizationsTab />,
    payments: <PaymentsTab />,
  };

  return (
    // Каркас по артборду «Админка»: навигация колонкой слева прямо на фоне
    // страницы, содержимое рядом. Возврат и заголовок — строкой сверху, той же
    // формы, что верхняя строка основного приложения.
    // font-ui — шрифт продукта: без него админка набиралась системным шрифтом
    // и вкладки выглядели по-разному (замечание владельца 28.09.2026).
    <div className="flex flex-1 min-h-0 flex-col gap-3 font-ui">
      {/* Своей строки «Платформа / Администрирование» нет (замечание владельца
          24.09.2026): «Платформа» была кнопкой «назад» на предыдущий экран —
          чаще всего в личный кабинет, откуда открывают админку, — и читалась
          как непонятный переход. Название — в общей верхней строке. */}

      <div className="flex min-h-0 flex-1 gap-3">
        <AdminSidebar active={active} onSelect={select} badges={{ users: candidateCount || null }} />
        <div className="min-w-0 flex-1">{TABS[active]}</div>
      </div>
    </div>
  );
}

// Ключи вкладок для теста «панель и вкладки не разъехались». Сама карта
// собирается внутри компонента — ей нужны его колбэки, — поэтому наружу
// отдаются только имена, и держать их в согласии обязан тест.
export const TABS_FOR_TEST = {
  users: true, domains: true, metrics: true, queue: true, abandoned: true,
  prompts: true, rates: true, settings: true, billing: true,
  trials: true, organizations: true, payments: true,
};
